<template>
  <v-app>
    <v-container fluid>
      <v-row no-gutters>
        <v-col cols="7" class="main-part d-none d-md-none d-lg-flex">
          <div class="d-flex">
            <v-img src="@/assets/logo-projeto.png" contain></v-img>
          </div>
        </v-col>
        <v-col cols="12" lg="5" class="login-part d-flex align-center justify-center">
          <v-row no-gutters class="align-start">
            <v-col cols="12" class="login-part d-flex align-center justify-center flex-column">
              <div class="login-wrapper pt-16 pt-sm-0">
                      <v-container>
                        <v-row class="flex-column">
                          <v-col>
                            <p class="login-slogan text-center font-weight-medium my-10">Faça seu login</p>
                          </v-col>
                          <v-form
                            ref="log"
                            v-model="valid"
                            lazy-validation
                            @submit.prevent="submit"
                          >
                            <v-col>
                              <v-text-field
                                light
                                id="email"
                                ref="email"
                                v-model="email"
                                :rules="emailRules"
                                single-line
                                label="E-mail"
                                required
                              ></v-text-field>
                              <v-text-field
                                light
                                id="password"
                                ref="password"
                                v-model="password"
                                :rules="passRules"
                                single-line
                                type="password"
                                label="Senha"
                                required
                              ></v-text-field>
                            </v-col>
                            <v-col class="d-flex justify-space-between">
                              <v-btn
                                class="text-capitalize"
                                large
                                :disabled="password.length === 0 || email.length === 0"
                                :loading="isFetching"
                                color="primary"
                                type="submit">
                                Login
                              </v-btn>
                              <v-btn
                                @click="esqueciMinhaSenha"
                                large
                                text
                                class="text-capitalize primary--text">
                                Solicitar nova senha
                              </v-btn>
                            </v-col>
                          </v-form>
                        </v-row>
                      </v-container>
              </div>
            </v-col>

            <v-col cols="12" class="d-flex justify-center">
              <v-footer>
                <div class="primary--text">
                  {{ new Date().getFullYear() }} &copy; Sistema de Monitoramento
                  - Feito por <a title="NPI – Núcleo de Práticas em Informática" href="https://www.quixada.ufc.br/npi-nucleo-de-praticas-em-informatica/" target="_blank">NPI</a> &amp; <a title="WeWorld" href="https://www.weworld.it/pt" target="_blank">WeWorld</a>
                </div>
              </v-footer>
            </v-col>


          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <v-snackbar
      top
      v-model="alert"
      color="error">
      {{ message }}
      <template v-slot:action="{ attrs }">
        <v-btn
          dark
          text
          v-bind="attrs"
          @click="alert = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Login',
  data() {
    return {
      valid: true,
      loginTabs: '',
      email: '',
      emailRules: [
        v => !!v || 'E-mail é obrigatório',
        v => /.+@.+/.test(v) || 'E-mail deve ser válido',
        v => v.toLowerCase() === this.email
      ],
      password: '',
      passRules: [
        v => !!v || 'Senha é obrigatória',
        v => v.length >= 6 || 'Mínimo de 6 caracteres'
      ],
      alert: false,
      message: ''
    }
  },
  methods: {
    submit() {
      this.$store.dispatch("auth/login", {
        username: this.email,
        password: this.password
        }).then(() => {
          if (this.$store.getters["auth/isAuthenticated"]) {
            this.to ? this.$router.push({path: this.to}) : this.$router.push({path: "/inicio"});
          } else {
            this.message = "Usuário e/ou senha inválidos";
            this.alert = true;
          }
      });
    },
    esqueciMinhaSenha() {
      this.$router.push({name: 'RecuperaSenha'});          
    }
  },
  computed: {
    ...mapState('auth', {
      isFetching: state => state.isFetching,
    }),
  },
  watch: {
    errorMessage() {
      this.message = this.errorMessage;
      this.alert = true;

    },
    regErrorMessage() {
      this.message = this.regErrorMessage;
      this.alert = true;
    }
  },

  created() {
  },
}

</script>

<style src="./Login.scss" lang="scss"/>
